<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.1 22.7H3.4a2 2 0 0 1-2-2V3.1c0-1.1.9-2 2-2H21a2 2 0 0 1 2 2v17.6c.1 1.1-.8 2-1.9 2M3.4 2c-.5 0-1 .5-1 1.1v17.6c0 .6.5 1.1 1.1 1.1h17.6c.6 0 1.1-.5 1.1-1.1V3.1c0-.6-.5-1.1-1.1-1.1zm5-.5h.9v20.7h-.9zm6.8 0h.9v20.7h-.9zM1.9 8h20.7v.9H1.9zm0 6.9h20.7v.9H1.9z"/></svg>
</template>
